/* EU customs popup — delayed 30s + online-only + cooldown (geo-popup.js) */

(function () {
  const STORAGE_KEY = "geo-popup-last-shown"; // stores a timestamp (ms)
  const COOLDOWN_DAYS = 30;                  // "in the past" window (change if you want)
  const DELAY_MS = 12 * 1000;                // 12 seconds
  const FETCH_TIMEOUT_MS = 4500;

  const euCountries = [
    "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT",
    "LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"
  ];

  function now() { return Date.now(); }

  function hasSeenRecently() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const last = Number(raw);
    if (!Number.isFinite(last)) return false;
    const cooldownMs = COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
    return (now() - last) < cooldownMs;
  }

  function markShown() {
    localStorage.setItem(STORAGE_KEY, String(now()));
  }

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function waitForOnline() {
    if (navigator.onLine) return Promise.resolve();
    return new Promise((resolve) => {
      const handler = () => {
        window.removeEventListener("online", handler);
        resolve();
      };
      window.addEventListener("online", handler, { once: true });
    });
  }

  function fetchWithTimeout(url, timeoutMs) {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), timeoutMs);
    return fetch(url, { signal: controller.signal, cache: "no-store" })
      .finally(() => clearTimeout(t));
  }

  function getLanguageCopy() {
    const path = location.pathname;
    const url = location.href;

    let heading = "Customs-Free Shipping!";
    let msg = "We ship directly from within the European Union. That means no unexpected customs charges for your order!";
    let ok = "Got it!";

    if (path.includes("/es") || url.includes("/es")) {
      heading = "¡Envío sin aranceles!";
      msg = "Enviamos directamente desde la Unión Europea. ¡Eso significa que no habrá cargos aduaneros inesperados para tu pedido!";
      ok = "¡Entendido!";
    } else if (path.includes("/it") || url.includes("/it")) {
      heading = "Spedizione senza dazi doganali!";
      msg = "Spediamo direttamente dall'interno dell'Unione Europea. Ciò significa nessun costo doganale inaspettato per il tuo ordine!";
      ok = "Capito!";
    }

    return { heading, msg, ok };
  }

  function injectStyles() {
    const style = document.createElement("style");
    style.textContent = `
      #geo-backdrop{
        position:fixed; inset:0; background:rgba(0,0,0,.35);
        z-index: 999; opacity:0; transition:opacity .2s ease;
      }
      #geo-popup{
        position:fixed; left:50%; transform:translateX(-50%);
        background:#fff; border:2px solid #11420C; border-radius:14px;
        box-shadow:0 8px 24px rgba(0,0,0,.25); z-index:1000;
        max-width:420px; width:92vw; top:10vh; padding:18px 16px 14px;
        max-height:80vh; overflow:auto; text-align:center;
        font-family:Assistant, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
      }
      #geo-popup h3{ color:#11420C; font-size:20px; line-height:1.2; margin:0 0 10px; }
      #geo-popup p{ font-size:16px; line-height:1.45; color:#121212; margin:10px 0 16px; }
      #geo-popup img{ display:block; width:100%; max-width:260px; margin:8px auto 8px; border-radius:10px; }
      #geo-popup .geo-actions{ display:flex; gap:8px; }
      #geo-popup .geo-ok{
        flex:1; padding:12px 14px; background:#11420C; color:#fff; border:none;
        border-radius:10px; font-weight:600; cursor:pointer;
      }
      #geo-popup .geo-close{
        position:absolute; top:8px; right:10px; width:34px; height:34px;
        border:none; background:transparent; color:#11420C; font-size:22px; cursor:pointer;
      }
      @media (max-width:768px){
        #geo-popup{
          bottom:16px; top:auto; width:94vw; border-radius:16px;
          padding:16px 14px 12px; max-height:70vh;
        }
        #geo-popup h3{ font-size:18px; }
        #geo-popup p{ font-size:14px; }
        #geo-popup img{ max-width:180px; margin:6px auto 6px; }
      }
    `;
    document.head.appendChild(style);
  }

  function showPopup(copy) {
    // If another script already injected it, bail.
    if (document.getElementById("geo-popup") || document.getElementById("geo-backdrop")) return;

    injectStyles();

    const backdrop = document.createElement("div");
    backdrop.id = "geo-backdrop";

    const popup = document.createElement("div");
    popup.id = "geo-popup";
    popup.setAttribute("role", "dialog");
    popup.setAttribute("aria-modal", "true");
    popup.innerHTML = `
      <button class="geo-close" aria-label="Close">×</button>
      <h3>${copy.heading}</h3>
      <img src="https://cdn.shopify.com/s/files/1/0440/4864/6304/files/european-silhouette.jpg?v=1733954491" alt="EU Silhouette">
      <p>${copy.msg}</p>
      <div class="geo-actions">
        <button class="geo-ok">${copy.ok}</button>
      </div>
    `;

    const close = () => {
      document.body.style.overflow = "";
      backdrop.style.opacity = "0";
      setTimeout(() => { popup.remove(); backdrop.remove(); }, 200);
      markShown(); // mark as "seen" when closed
    };

    backdrop.addEventListener("click", close);
    popup.querySelector(".geo-close").addEventListener("click", close);
    popup.querySelector(".geo-ok").addEventListener("click", close);

    document.body.appendChild(backdrop);
    document.body.appendChild(popup);

    requestAnimationFrame(() => { backdrop.style.opacity = "1"; });
    document.body.style.overflow = "hidden";
  }

  async function run() {
    // Cooldown gate
    if (hasSeenRecently()) return;

    // Must be online (or wait until they are)
    await waitForOnline();

    // If they went offline again immediately, bail.
    if (!navigator.onLine) return;

    // If user switched tabs, still okay — but don’t pop instantly on return.
    // (We already waited 30s, so keep it simple.)

    // Geo lookup (timeout to avoid hanging)
    let data;
    try {
      const r = await fetchWithTimeout("https://ipapi.co/json/", FETCH_TIMEOUT_MS);
      if (!r.ok) return;
      data = await r.json();
    } catch (e) {
      // If blocked/aborted, just fail silently (no popup)
      return;
    }

    const userCountry = data && data.country_code;
    if (!userCountry || !euCountries.includes(userCountry)) return;

    const copy = getLanguageCopy();

    // Optional: show during idle time to reduce main-thread contention
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => showPopup(copy), { timeout: 1500 });
    } else {
      showPopup(copy);
    }
  }

  // Start AFTER DOM is ready, then wait 30 seconds “time on site”
  function boot() {
    // Don’t set timers if they’ve already seen it recently
    if (hasSeenRecently()) return;

    wait(DELAY_MS).then(run);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();